import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Procedure")
], -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Describe the research purpose")
], -1)
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Describe the research method")
], -1)
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Describe specific procedures"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "Definition: ''Research procedure'' in human subject research encompass the systematic steps and methods followed by researchers to collect data, conduct interventions, and implement study protocols in order to address the research objectives.) and duration of time subject participation is requested (starting with administering informed consent). As applicable, this should include a timeline for recruitment, administration of informed consent, and administration of any measures used, including intervention frequency and duration for all subjects"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_IrbGptSection = _resolveComponent("IrbGptSection")!
  const _component_editor = _resolveComponent("editor")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"]),
      _createVNode(_component_IrbGptSection)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_editor, {
          for: "purpose",
          initialValue: "",
          modelValue: _ctx.step2.purpose,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step2.purpose) = $event)),
          "api-key": _ctx.currentEditorToken,
          licenseKey: "gpl",
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "purpose",
          initialValue: "",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "Type purpose",
          modelValue: _ctx.step2.purpose,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step2.purpose) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "purpose",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_editor, {
          for: "method",
          initialValue: "",
          modelValue: _ctx.step2.method,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step2.method) = $event)),
          licenseKey: "gpl",
          "api-key": _ctx.currentEditorToken,
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "method",
          initialValue: "",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "Type method",
          modelValue: _ctx.step2.method,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step2.method) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "method",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_editor, {
          for: "procedure",
          initialValue: "",
          modelValue: _ctx.step2.procedure,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step2.procedure) = $event)),
          licenseKey: "gpl",
          "api-key": _ctx.currentEditorToken,
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          initialValue: "",
          name: "procedure",
          for: "procedure",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "Research rocedure",
          modelValue: _ctx.step2.procedure,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step2.procedure) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "procedure",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ])
  ]))
}